import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SeFeApiService } from 'se-fe-api'

import { AdminInviteCreateParams } from '@se-po/shared-data-access-models'

@Injectable({
  providedIn: 'root',
})
export class AdminInviteService {
  constructor(private api: SeFeApiService) {
    // noop
  }

  public create(
    orgId: string,
    params: AdminInviteCreateParams
  ): Observable<any> {
    return this.api.post(`v3/organizations/${orgId}/admin_invites`, params)
  }

  public resend(orgId: string, inviteId: string): Observable<any> {
    return this.api.post(`v3/organizations/${orgId}/admin_invites/${inviteId}/resend_email`, {})
  }

  public delete(orgId: string, inviteId: string): Observable<any> {
    return this.api.delete(`v3/organizations/${orgId}/admin_invites/${inviteId}`)
  }
}
